<template>
  <div class="animated revealUp" style="zoom: 0.9">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $t("customization") }}
      </div>
      <router-link class="btn-blue" to="/fnb/customization"
        >{{ $t("customization") }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-4 col-xl-3 align-self-center">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="fnb_item.item_code"
                name="alpha_dash"
                id="itemcode"
                v-validate="'required|alpha_dash'"
              />
              <label>{{ $t("itemcode") }}</label>
            </div>
            <!-- <Tooltip :title="$t('fnbitems_itemCode_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('itemcode')">{{
              errors.first("itemcode")
            }}</span>
          </p>
        </div>

        <div class="col-lg-4 col-xl-3 align-self-center">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="fnb_item.item_name"
                @input="onChangeItemName($event, 'name')"
                name="itemname"
                id="itemname"
                v-validate="'required'"
              />
              <label>{{ $t("itemname") }}</label>
            </div>
            <!-- <Tooltip :title="$t('itemname')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('itemname')">{{
              errors.first("itemname")
            }}</span>
          </p>
        </div>

        <div class="col-lg-4 col-xl-3 align-self-center">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="fnb_item.item_description"
                @input="onChangeItemName($event, 'desc')"
                name="itemdesc"
                id="itemdesc"
                v-validate="'required'"
              />
              <label>{{ $t("description") }}</label>
            </div>
            <!-- <Tooltip :title="$t('fnbitems_itemdescription_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('itemdesc')">{{
              errors.first("itemdesc")
            }}</span>
          </p>
        </div>
        <section
          class="mb-2 col-lg-12 col-xl-12 align-self-center"
          v-if="false"
        >
          <div class="bn-tabs-nav">
            <button
              v-for="(fnbContent, fnbContentIndex) in FnbItemContent"
              :key="fnbContentIndex"
              :class="[
                'btn-tab-title ',
                { active: fnbContentIndex == activeClass },
              ]"
              @click.prevent.stop="onChangeTabHandler($event, fnbContentIndex)"
            >
              <strong>
                <span
                  :class="
                    fnbContent.langauge.toLowerCase() !== 'english'
                      ? notempty[fnbContentIndex]
                        ? ''
                        : 'text-danger'
                      : ''
                  "
                  >{{ fnbContent.langauge }}</span
                >
              </strong>
            </button>
          </div>
          <div class="bn-tabs-content">
            <div
              v-for="(fnbContent, fnbContentIndex) in FnbItemContent"
              :key="fnbContentIndex"
            >
              <div v-if="fnbContentIndex === activeClass">
                <div class="row">
                  <div class="col-lg-6 col-xl-6 align-self-center">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          placeholder="."
                          type="text"
                          v-model="fnbContent.item_name"
                          name="itemnamelang"
                          id="itemnamelang"
                          @input="
                            CheckEmptyContent(fnbContent, fnbContentIndex)
                          "
                          v-validate="
                            fnbContent.langauge.toLowerCase() === 'english'
                              ? 'required'
                              : ''
                          "
                        />
                        <label>{{ $t("itemname") }}</label>
                      </div>
                      <!-- <Tooltip :title="$t('itemname')" /> -->
                    </div>
                    <p
                      v-if="fnbContent.langauge.toLowerCase() !== 'english'"
                      class="fs-12"
                    >
                      (Optional)
                    </p>
                    <p class="error_message">
                      <span v-if="submitted && errors.has('itemnamelang')">{{
                        errors.first("itemnamelang")
                      }}</span>
                    </p>
                  </div>

                  <div class="col-lg-6 col-xl-6 align-self-center">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          placeholder="."
                          type="text"
                          v-model="fnbContent.item_description"
                          name="itemdesclang"
                          id="itemdesclang"
                          @input="
                            CheckEmptyContent(fnbContent, fnbContentIndex)
                          "
                          v-validate="
                            fnbContent.langauge.toLowerCase() === 'english'
                              ? 'required'
                              : ''
                          "
                        />
                        <label>{{ $t("description") }}</label>
                      </div>
                      <!-- <Tooltip
                        :title="$t('fnbitems_itemdescription_tooltip')"
                      /> -->
                    </div>
                    <p
                      v-if="fnbContent.langauge.toLowerCase() !== 'english'"
                      class="fs-12"
                    >
                      (Optional)
                    </p>
                    <p class="error_message">
                      <span v-if="submitted && errors.has('itemdesclang')">{{
                        errors.first("itemdesclang")
                      }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div class="col-lg-4 col-xl-3 align-self-center">
          <div class="dropdown-curve-container">
            <label :class="fc_parent_label.length > 0 ? 'shift-up' : ''">{{
              $tc("category", 1)
            }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="fc_parent_label"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Categories"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchFoodCategories()"
                    v-on:keydown="onSearchFoodCategories()"
                    v-on:search="onSearchFoodCategories()"
                    v-model="searchFoodCategories"
                  />
                </div>
                <b-dropdown-item
                  v-for="(fc, fcIndex) in ms_food_categories"
                  :key="fcIndex"
                  href="#"
                  @click="
                    fnb_item.fc_id = fc.fc_id;
                    fc_parent_label = fc.fc_category;
                    searchFoodCategories = '';
                    onSearchFoodCategories();
                  "
                  >{{ fc.fc_category }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="$t('fnbitems_foodcategory_tooltip')" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && fc_parent_label.length == 0"
                >Please Select Food Category.</span
              >
            </p>
          </div>
        </div>

        <div class="col-lg-4 col-xl-3 align-self-center">
          <div class="d-flex justify-content-between align-item-center">
            <label
              class="material-file-upload"
              @click.prevent.stop="setModalData(280, 460)"
            >
              <div
                class="label"
                v-bind:class="{
                  'shift-up': fnb_item.item_image_url,
                }"
              >
                {{ "Item Image" }}
              </div>
              <div class="uploaded-file-name">
                <div class="text-truncate pt-2 image_url_text">
                  {{ fnb_item.item_image_url }}
                </div>
              </div>
            </label>

            <!-- <Tooltip
              class="mt-2"
              :title="
                `Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg`
              "
            /> -->
            <img
              width="40"
              height="40"
              class="rounded ml-2"
              @click="showFnbImage()"
              :src="_GetImagePath(fnb_item.item_image_url)"
              v-if="fnb_item.item_image_url.length > 0"
              v-b-tooltip.hover.top="
                'Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg'
              "
            />
            <img
              v-else
              width="35"
              height="35"
              class="rounded ml-2"
              alt="Empty Image"
              src="@/assets/img/icons/empty-image.svg"
              v-b-tooltip.hover.top="
                'Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg'
              "
            />
          </div>
          <p class="error_message">
            <!-- <span v-if="submitted && fnb_item.item_image_url.length == 0"
              >Please Select Food Image File.</span
            > -->
          </p>
        </div>

        <div>
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            <!-- <label class="ios-switch ml-2"> -->
            <b-form-checkbox
              v-model="fnb_item.item_is_active"
              type="checkbox"
              class="j-checkbox"
              checked
            />
            <!-- <span class="switch-slider"></span>
            </label> -->
          </div>
        </div>

        <div class="col-lg-3 col-xl-4 align-self-center mb-3" v-if="false">
          <div class="d-flex align-items-center mb-4">
            <span>{{ $t("isSundry") }}</span>
            <b-form-checkbox
              class="j-checkbox ml-3"
              v-model="fnb_item.is_sundry"
              unchecked-value="N"
              value="Y"
              switch
            ></b-form-checkbox>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-3" v-if="false">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("isveg") }}</label>
            <!-- <label class="ios-switch ml-2"> -->
            <b-form-checkbox
              v-model="fnb_item.item_is_veg"
              type="checkbox"
              class="j-checkbox"
              checked
            />
            <!-- <span class="switch-slider"></span>
            </label> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div
          class="col-lg-6 col-xl-4 align-self-center mb-3"
          v-if="fnb_item.item_is_veg && false"
        >
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("includesegg") }}</label>
            <!-- <label class="ios-switch ml-2"> -->
            <b-form-checkbox
              v-model="fnb_item.includes_egg"
              type="checkbox"
              class="j-checkbox"
              checked
            />
            <!-- <span class="switch-slider"></span>
            </label> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div
          class="col-lg-6 col-xl-4 align-self-center mb-3"
          v-if="fnb_item.item_is_veg && false"
        >
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("isPackageitem") }}</label>
            <!-- <label class="ios-switch ml-2"> -->
            <b-form-checkbox
              v-model="fnb_item.is_package_item"
              type="checkbox"
              class="j-checkbox ml-2"
              checked
            />
            <!-- <span class="switch-slider"></span>
            </label> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12">
          <div class="section-title mb-3">
            {{ $tc("price", 1) }} {{ $tc("details", 2) }}
          </div>
        </div>

        <div
          v-for="(singleCinema, CinemaIndex) in CinemaPriceSettings"
          :key="CinemaIndex"
          class="col-md-12 mb-4 chargeSettingRow"
        >
          <div class="row">
            <!-- SELECT CINEMA -->
            <div class="col-11">
              <div class="row chargeSettingInnerWrap">
                <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                  <div class="dropdown-curve-container">
                    <multiselect
                      :options="cinemaListCopy"
                      v-model="singleCinema.selectedCinemas"
                      :searchable="true"
                      label="cine_name"
                      track-by="cine_id"
                      placeholder="Select Cinema"
                      @input="onDropdownChange($event, CinemaIndex)"
                      :allowEmpty="false"
                      :showLabels="false"
                    ></multiselect>
                    <p
                      v-if="
                        submitted && singleCinema.selectedCinema.length == 0
                      "
                      class="error_message"
                    >
                      Please Select Cinema.
                    </p>
                  </div>
                </div>

                <!-- SELECT RECIPE -->
                <div class="col-lg-4 col-xl-3 align-self-center">
                  <div class="dropdown-curve-container">
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <multiselect
                        :options="recipes"
                        :searchable="true"
                        :placeholder="
                          singleCinema.recipe_label &&
                          singleCinema.recipe_label.length > 0
                            ? singleCinema.recipe_label
                            : 'Recipe Optional'
                        "
                        label="recipe_name"
                        track-by="recipe_id"
                        @select="
                          onSelectFnbItem($event, CinemaIndex);
                          fnb_item.recipe_id = $event.recipe_id;
                          singleCinema.recipe_label = $event.recipe_name;
                        "
                        :allowEmpty="false"
                        :showLabels="false"
                      ></multiselect>
                    </div>
                    <p class="error_message">
                      <span></span>
                    </p>
                  </div>
                </div>

                <!-- ITEM COST PRICE -->
                <div class="col-lg-4 col-xl-2 align-self-center">
                  <div class="d-flex align-items-center mb-4">
                    <div class="input-material">
                      <input
                        placeholder="."
                        type="text"
                        v-model="singleCinema.itemcost_price.costprice"
                        name="costprice"
                        id="costprice"
                        v-validate="'required|decimal'"
                      />
                      <label>{{ $t("itemcostprice") }}</label>
                    </div>
                    <!-- <Tooltip :title="$t('itemcostprice_costPrice')" /> -->
                  </div>
                  <p
                    v-if="submitted && errors.has('costprice')"
                    class="error_message"
                  >
                    {{ errors.first("costprice") }}
                  </p>
                </div>

                <!-- FNB PRICE -->
                <div class="col-lg-4 col-xl-2 align-self-center mb-4">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        placeholder="."
                        v-model="singleCinema.ratecard.frc_amount"
                        v-on:keyup="onChangeRatecardAmount($event, CinemaIndex)"
                        type="text"
                        name="cardamount"
                        id="cardamount"
                        v-validate="{
                          required: 'required',
                          regex: '[0-9]|[0-9]*\\.[0-9]*$',
                        }"
                      />
                      <label>{{ $t("amount") }}</label>
                    </div>
                    <!-- <Tooltip :title="$t('tooltip')" /> -->
                  </div>
                  <p
                    v-if="submitted && errors.has('cardamount')"
                    class="error_message"
                  >
                    {{ errors.first("cardamount") }}
                  </p>
                </div>

                <div
                  v-if="singleCinema.cinemaFlag"
                  class="col-lg-4 col-xl-2 align-self-center mb-4"
                >
                  <div class="d-flex align-items-center">
                    <div
                      v-if="
                        singleCinema.ratecard.frc_pas_setting_name &&
                        singleCinema.ratecard.frc_pas_setting_name.length > 0
                      "
                      class="input-material"
                    >
                      <input
                        placeholder="."
                        type="text"
                        v-model="singleCinema.ratecard.frc_pas_setting_name"
                        name="frc_pas_setting_name"
                        id="frc_pas_setting_name"
                        :disabled="true"
                      />
                      <label>{{ "Tax Setting" }}</label>
                    </div>
                  </div>
                </div>

                <!-- CHARGE SETTING NAME -->
                <div v-else class="col-lg-4 col-xl-2 align-self-center mb-4">
                  <div class="dropdown-curve-container">
                    <!-- <label
                  :class="singleCinema.selectedChargeSettingName.length > 0 ? 'shift-up' : '' "
                >{{ $tc('chargesettingname', 1) }}</label>-->
                    <!-- <b-dropdown
                  :text="singleCinema.selectedChargeSettingName"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <b-dropdown-item
                    v-for="(dropdownItem,dropdownIndex) in singleCinema.pas_setting_name_list"
                    :key="dropdownIndex"
                    href="#"
                    @click="onChangeSettingName($event, dropdownItem,CinemaIndex)"
                  >{{ dropdownItem.pas_charge_setting_name }}</b-dropdown-item>
                </b-dropdown>-->
                    <multiselect
                      :options="singleCinema.pas_setting_name_list"
                      :searchable="true"
                      :placeholder="
                        singleCinema.selectedChargeSettingName.length > 0
                          ? singleCinema.selectedChargeSettingName
                          : 'Select Charge Setting'
                      "
                      label="pas_charge_setting_name"
                      track-by="pas_id"
                      @select="onChangeSettingName($event, $event, CinemaIndex)"
                      :allowEmpty="false"
                      :showLabels="false"
                    ></multiselect>
                    <p
                      v-if="
                        submitted &&
                        singleCinema.selectedChargeSettingName.length == 0
                      "
                      class="error_message"
                    >
                      Please Select Charge Setting Name.
                    </p>
                  </div>
                </div>

                <!-- FROM DATE -->
                <div class="col-lg-4 col-xl-3 align-self-center" v-if="false">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <div class="add-datepicker">
                        <button
                          class="btn-clearDate"
                          v-if="singleCinema.ms_fnb_price.fp_from_date"
                          @click="resetFromDate(CinemaIndex)"
                        >
                          ✖
                        </button>
                        <Datepicker
                          :monday-first="true"
                          ref="programaticOpen"
                          v-model="singleCinema.ms_fnb_price.fp_from_date"
                          name="fdate1"
                          id="fdate1"
                          typeable
                          v-validate="'required'"
                        ></Datepicker>
                        <label
                          :class="
                            typeof singleCinema.ms_fnb_price.fp_from_date ===
                            'object'
                              ? 'active'
                              : ''
                          "
                          >From Date</label
                        >
                      </div>
                    </div>
                    <!-- <Tooltip :title="$t('fnbpricing_fromdate')" /> -->
                  </div>
                  <p
                    v-if="submitted && errors.has('fdate1')"
                    class="error_message"
                  >
                    {{ errors.first("fdate1") }}
                  </p>
                </div>

                <!-- TO DATE -->
                <div class="col-lg-4 col-xl-3 align-self-center" v-if="false">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <div class="add-datepicker">
                        <button
                          class="btn-clearDate"
                          v-if="singleCinema.ms_fnb_price.fp_to_date"
                          @click="resetToDate(CinemaIndex)"
                        >
                          ✖
                        </button>
                        <Datepicker
                          :monday-first="true"
                          ref="programaticOpen"
                          v-model="singleCinema.ms_fnb_price.fp_to_date"
                          name="tdate1"
                          id="tdate1"
                          typeable
                        ></Datepicker>
                        <label
                          :class="
                            typeof singleCinema.ms_fnb_price.fp_to_date ===
                            'object'
                              ? 'active'
                              : ''
                          "
                          >To Date</label
                        >
                      </div>
                    </div>
                    <!-- <Tooltip :title="$t('fnbpricing_todate')" /> -->
                  </div>
                  <p class="text-muted fs-12">({{ $t("optional") }})</p>
                </div>

                <template v-if="showErpColumns">
                  <div class="col-lg-2 col-xl-2 align-self-center">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          style="text-align: right"
                          placeholder="."
                          type="text"
                          v-model="singleCinema.report_code"
                          name="report_code"
                          id="report_code"
                          v-validate=""
                        />
                        <label>{{ "Report Code" }}</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-2 col-xl-2 align-self-center">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          style="text-align: right"
                          placeholder="."
                          type="text"
                          v-model="singleCinema.gl_account"
                          name="gl_account"
                          id="gl_account"
                          v-validate=""
                        />
                        <label>{{ "GL Account" }}</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-2 col-xl-2 align-self-center">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          style="text-align: right"
                          placeholder="."
                          type="text"
                          v-model="singleCinema.gl_desc"
                          name="gl_desc"
                          id="gl_desc"
                          v-validate=""
                        />
                        <label>{{ "GL Desc." }}</label>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- CHARGE IS INCLUSIVE SWITCH -->
                <div class="col-lg-4 col-xl-3 align-self-center">
                  <div class="d-flex align-items-center">
                    <label class="mb-0 mr-3">{{ $t("inclusivoftax") }}</label>
                    <b-form-checkbox
                      class="j-checkbox"
                      unchecked-value="N"
                      value="Y"
                      v-model="singleCinema.ratecard.frc_is_active_inclusivtax"
                      name="check-button"
                      @change="OnSwitchHandler($event, CinemaIndex)"
                      switch
                    ></b-form-checkbox>
                  </div>
                </div>

                <div
                  class="col-md-12 mt-4"
                  v-if="
                    singleCinema.cinemaChargesList &&
                    singleCinema.cinemaChargesList.length
                  "
                >
                  <table class="table table-bordered col-xl-8">
                    <tbody>
                      <tr
                        v-for="(
                          cinemaCharge, cinemaChargesListIndex
                        ) in singleCinema.cinemaChargesList"
                        :key="cinemaChargesListIndex"
                        class="main_border_edit"
                      >
                        <td
                          class=""
                          style="
                            padding: 4px 10px;
                            color: black;
                            font-weight: bold;
                          "
                        >
                          {{ cinemaCharge.ct_name }}
                        </td>
                        <td
                          class=""
                          style="
                            padding: 4px 10px;
                            color: black;
                            font-weight: bold;
                            text-align: right;
                          "
                        >
                          {{ cinemaCharge.pas_charge_value }}
                          {{
                            cinemaCharge.pas_is_percentage === "Y" ? "%" : ""
                          }}
                        </td>
                        <td
                          class=""
                          style="
                            padding: 4px 10px;
                            color: black;
                            font-weight: bold;
                            text-align: right;
                          "
                        >
                          {{
                            parseFloat(cinemaCharge.cinemacharges || 0).toFixed(
                              4
                            ) || 0
                          }}
                        </td>
                      </tr>
                      <tr class="main_border_edit">
                        <td style="padding: 4px 10px">
                          <div>
                            <span class="font-weight-bold">Net Amount:</span>
                            <span
                              >{{ currencyData.curr_code }}
                              {{
                                parseFloat(
                                  singleCinema.ratecard.frc_net_amount || 0
                                ).toFixed(MIN_FRACTION_DIGITS) || 0
                              }}</span
                            >
                          </div>
                        </td>
                        <td style="padding: 4px 10px">
                          <div>
                            <span class="font-weight-bold">Gross Total:</span>
                            <span
                              >{{ currencyData.curr_code }}
                              {{
                                parseFloat(
                                  singleCinema.ratecard.frc_total_amount || 0
                                ).toFixed(MIN_FRACTION_DIGITS) || 0
                              }}</span
                            >
                          </div>
                        </td>
                        <td style="padding: 4px 10px">
                          <div>
                            <span class="font-weight-bold">Food Cost %:</span>
                            <span v-if="singleCinema.ratecard.frc_total_amount">
                              {{
                                (
                                  parseFloat(
                                    singleCinema.itemcost_price.costprice || 0
                                  ) /
                                  parseFloat(
                                    singleCinema.ratecard.frc_total_amount || 0
                                  )
                                ).toFixed(MIN_FRACTION_DIGITS) * 100 || 0 | RoundOff
                              }}%
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div
              class="col-lg-1 d-flex align-items-center justify-content-center"
            >
              <!-- <button
                v-if="CinemaIndex == 0"
                @click.prevent.stop="addCinemaSetting(CinemaIndex)"
                class="btn-transparent"
                :disabled="isRoleID"
              >
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button> -->
              <button
                v-if="CinemaPriceSettings && CinemaPriceSettings.length > 1"
                @click.prevent.stop="removeCinemaSettings(CinemaIndex)"
                class="btn-transparent"
              >
                <img
                  src="@/assets/img/icons/minus.svg"
                  height="35"
                  width="35"
                />
              </button>
            </div>

            <!-- DAYS -->
            <div class="row ml-2" v-if="false">
              <div class="col-lg-3 col-xl-2">
                <div>{{ $t("select") }} {{ $t("days") }}:</div>
              </div>
              <div class="col-lg-9 col-xl-10 pl-0">
                <div class="row">
                  <b-form-checkbox
                    v-for="(weekdaysLoop, weekdaysKey) in singleCinema.weekDays"
                    :key="weekdaysKey"
                    style="min-width: 125px"
                    class="j-checkbox mb-3"
                    @change="onChangeWeekdays($event, weekdaysKey, CinemaIndex)"
                    v-model="singleCinema.weekDays[weekdaysKey]"
                  >
                    <div class="text-capitalize">{{ weekdaysKey }}</div>
                  </b-form-checkbox>
                </div>
              </div>
            </div>

            <!-- CHARGE SETTINGS -->
            <div class="col-md-12" v-if="false">
              <div>
                <div class="font-weight-bold mb-2">
                  {{ $t("add") }} {{ $tc("charge", 2) }}
                </div>
              </div>

              <div
                class="col-12"
                v-for="(
                  cinemaCharge, cinemaChargesListIndex
                ) in singleCinema.cinemaChargesList"
                :key="cinemaChargesListIndex"
              >
                <div class="row">
                  <!-- IMAGE DIMENSION -->
                  <div class="col-md-5 mb-4">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <!-- <input v-model="cinemaCharge.rc_name" type="text" required="required" /> -->
                        <label>{{ cinemaCharge.ct_name }}</label>
                      </div>
                    </div>
                    <!-- <p class="error_msg">Invalid Entry</p> -->
                  </div>
                  <div class="col-md-7">
                    <div class="row">
                      <div class="col-md-5">
                        <div
                          class="d-flex justify-content-center align-items-center p-3"
                        >
                          <label
                            >{{ cinemaCharge.pas_charge_value
                            }}{{
                              cinemaCharge.pas_is_percentage == "Y" ? "%" : ""
                            }}</label
                          >
                        </div>
                      </div>
                      <div class="col-md-5">
                        <div
                          class="d-flex justify-content-center align-items-center p-3"
                        >
                          <label>{{
                            cinemaCharge.cinemacharges.toFixed(4)
                          }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="text-right">
                  <div>
                    <span class="font-weight-bold">Net Amount:</span>
                    <span
                      >{{ currencyData.curr_code }}
                      {{
                        singleCinema.ratecard.frc_net_amount.toFixed(MIN_FRACTION_DIGITS)
                      }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="text-right">
                  <div>
                    <span class="font-weight-bold">Gross Total:</span>
                    <span
                      >{{ currencyData.curr_code }}
                      {{
                        singleCinema.ratecard.frc_total_amount.toFixed(MIN_FRACTION_DIGITS)
                      }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="text-right">
                  <div>
                    <span class="font-weight-bold">Food Cost %:</span>
                    <span v-if="singleCinema.ratecard.frc_total_amount"
                      >{{
                        ((
                          singleCinema.itemcost_price.costprice /
                          singleCinema.ratecard.frc_total_amount
                        ).toFixed(MIN_FRACTION_DIGITS) *
                          100)
                          | RoundOff
                      }}%</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="col-12 d-flex align-items-center justify-content-center border-top mt-4 mb-4 position-relative"
        >
          <button
            @click.prevent.stop="addCinemaSetting()"
            class="btn-transparent add-more-button"
          >
            <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
          </button>
        </div>

        <div
          v-for="(singleCinema, CinemaIndex) in CinemaPriceSettings"
          :key="CinemaIndex"
          class="col-md-12 mb-4"
          v-if="false"
        >
          <div class="row">
            <!-- SELECT CINEMA -->
            <div class="col-lg-6 col-xl-4 align-self-center mb-4">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    CinemaPriceSettings[CinemaIndex].cinema_id &&
                    String(CinemaPriceSettings[CinemaIndex].cinema_id).length >
                      0
                      ? 'shift-up'
                      : ''
                  "
                  >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
                >
                <multiselect
                  :options="cinemaListCopy"
                  v-model="singleCinema.selectedCinemas"
                  :searchable="true"
                  label="cine_name"
                  track-by="cine_id"
                  placeholder="Select Cinema"
                  @input="onDropdownChange($event, CinemaIndex)"
                  :allowEmpty="false"
                  :showLabels="false"
                  :disabled="isRoleID"
                ></multiselect>
                <p
                  v-if="submitted && singleCinema.selectedCinema.length == 0"
                  class="error_message"
                >
                  Please Select Cinema.
                </p>
              </div>
            </div>

            <!-- SELECT RECIPE -->
            <div class="col-lg-6 col-xl-4 align-self-center">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    CinemaPriceSettings[CinemaIndex].itemcost_price.item_id &&
                    String(
                      CinemaPriceSettings[CinemaIndex].itemcost_price.item_id
                    ).length > 0
                      ? 'shift-up'
                      : ''
                  "
                  >{{ $t("recipeoptional") }}</label
                >
                <div class="d-flex justify-content-center align-items-center">
                  <multiselect
                    :options="recipes"
                    :searchable="true"
                    :placeholder="
                      singleCinema.recipe_label.length > 0
                        ? singleCinema.recipe_label
                        : 'Recipe Optional'
                    "
                    label="recipe_name"
                    track-by="recipe_id"
                    @select="
                      onSelectFnbItem($event, CinemaIndex);
                      fnb_item.recipe_id = $event.recipe_id;
                      singleCinema.recipe_label = $event.recipe_name;
                    "
                    :allowEmpty="false"
                    :showLabels="false"
                  ></multiselect>
                  <!-- <Tooltip :title="$t('fnbitems_tooltip')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>
            </div>

            <!-- ITEM COST PRICE -->
            <div class="col-lg-6 col-xl-4 align-self-center">
              <div class="d-flex align-items-center mb-4">
                <div class="input-material">
                  <input
                    style="text-align: right"
                    placeholder="."
                    type="text"
                    v-model="singleCinema.itemcost_price.costprice"
                    name="costprice"
                    id="costprice"
                  />
                  <label>{{ $t("itemcostprice") }}</label>
                </div>
                <!-- <Tooltip :title="$t('itemcostprice_costPrice')" /> -->
              </div>
              <p
                v-if="submitted && errors.has('costprice')"
                class="error_message"
              >
                {{ errors.first("costprice") }}
              </p>
            </div>

            <!-- CHARGE SETTING NAME -->
            <div class="col-lg-6 col-xl-4 align-self-center mb-4">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    CinemaPriceSettings[CinemaIndex]
                      .selectedChargeSettingName &&
                    String(
                      CinemaPriceSettings[CinemaIndex].selectedChargeSettingName
                    ).length > 0
                      ? 'shift-up'
                      : ''
                  "
                  >Select Charge Setting</label
                >
                <multiselect
                  :options="singleCinema.pas_setting_name_list"
                  :searchable="true"
                  :placeholder="
                    singleCinema.selectedChargeSettingName.length > 0
                      ? singleCinema.selectedChargeSettingName
                      : 'Select Charge Setting'
                  "
                  label="pas_charge_setting_name"
                  track-by="pas_id"
                  @select="onChangeSettingName($event, $event, CinemaIndex)"
                  :allowEmpty="false"
                  :showLabels="false"
                ></multiselect>
                <p
                  v-if="
                    submitted &&
                    singleCinema.selectedChargeSettingName.length == 0
                  "
                  class="error_message"
                >
                  Please Select Charge Setting Name.
                </p>
              </div>
            </div>

            <!-- FNB PRICE -->
            <div class="col-lg-6 col-xl-4 align-self-center mb-4">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    style="text-align: right"
                    placeholder="."
                    v-model="singleCinema.ratecard.frc_amount"
                    v-on:keyup="onChangeRatecardAmount($event, CinemaIndex)"
                    type="text"
                    name="cardamount"
                    id="cardamount"
                    v-validate="{
                      required: 'required',
                      regex: '[0-9]|[0-9]*\\.[0-9]*$',
                    }"
                  />
                  <label>{{ $t("amount") }}</label>
                </div>
                <!-- <Tooltip :title="$t('customization_salesPrice_tooltip')" /> -->
              </div>
              <p
                v-if="submitted && errors.has('cardamount')"
                class="error_message"
              >
                {{ errors.first("cardamount") }}
              </p>
            </div>

            <!-- FROM DATE -->
            <div class="col-lg-6 col-xl-4 align-self-center mb-4">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <div class="add-datepicker">
                    <button
                      class="btn-clearDate"
                      v-if="singleCinema.ms_fnb_price.fp_from_date"
                      @click="resetFromDate(CinemaIndex)"
                    >
                      ✖
                    </button>
                    <Datepicker
                      :monday-first="true"
                      ref="programaticOpen"
                      v-model="singleCinema.ms_fnb_price.fp_from_date"
                      name="fdate1"
                      id="fdate1"
                      typeable
                      v-validate="'required'"
                    ></Datepicker>
                    <label
                      :class="
                        typeof singleCinema.ms_fnb_price.fp_from_date ===
                        'object'
                          ? 'active'
                          : ''
                      "
                      >From Date</label
                    >
                  </div>
                </div>
                <!-- <Tooltip :title="$t('fnbpricing_fromdate')" /> -->
              </div>
              <p v-if="submitted && errors.has('fdate1')" class="error_message">
                {{ errors.first("fdate1") }}
              </p>
            </div>

            <!-- TO DATE -->
            <div class="col-lg-6 col-xl-4 align-self-center mb-4">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <div class="add-datepicker">
                    <button
                      class="btn-clearDate"
                      v-if="singleCinema.ms_fnb_price.fp_to_date"
                      @click="resetToDate(CinemaIndex)"
                    >
                      ✖
                    </button>
                    <Datepicker
                      :monday-first="true"
                      ref="programaticOpen"
                      v-model="singleCinema.ms_fnb_price.fp_to_date"
                      name="tdate1"
                      id="tdate1"
                      typeable
                    ></Datepicker>
                    <label
                      :class="
                        typeof singleCinema.ms_fnb_price.fp_to_date === 'object'
                          ? 'active'
                          : ''
                      "
                      >To Date</label
                    >
                  </div>
                </div>
                <!-- <Tooltip :title="$t('fnbpricing_todate')" /> -->
              </div>
              <p class="text-muted fs-12">({{ $t("optional") }})</p>
            </div>

            <template v-if="showErpColumns">
              <div class="col-lg-2 col-xl-2 align-self-center">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      style="text-align: right"
                      placeholder="."
                      type="text"
                      v-model="singleCinema.report_code"
                      name="report_code"
                      id="report_code"
                      v-validate=""
                    />
                    <label>{{ "Report Code" }}</label>
                  </div>
                </div>
              </div>

              <div class="col-lg-2 col-xl-2 align-self-center">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      style="text-align: right"
                      placeholder="."
                      type="text"
                      v-model="singleCinema.gl_account"
                      name="gl_account"
                      id="gl_account"
                      v-validate=""
                    />
                    <label>{{ "GL Account" }}</label>
                  </div>
                </div>
              </div>

              <div class="col-lg-2 col-xl-2 align-self-center">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      style="text-align: right"
                      placeholder="."
                      type="text"
                      v-model="singleCinema.gl_desc"
                      name="gl_desc"
                      id="gl_desc"
                      v-validate=""
                    />
                    <label>{{ "GL Desc." }}</label>
                  </div>
                </div>
              </div>
            </template>

            <!-- CHARGE IS INCLUSIVE SWITCH -->
            <div class="col-lg-6 col-xl-4 align-self-center mb-4">
              <div class="d-flex align-items-center">
                <label class="mb-0 mr-3">{{ $t("inclusivoftax") }}</label>
                <b-form-checkbox
                  class="j-checkbox"
                  unchecked-value="N"
                  value="Y"
                  v-model="singleCinema.ratecard.frc_is_active_inclusivtax"
                  name="check-button"
                  @change="OnSwitchHandler($event, CinemaIndex)"
                  switch
                ></b-form-checkbox>
              </div>
            </div>

            <div
              class="col-lg-1 d-flex align-items-start justify-content-center"
            >
              <button
                v-if="CinemaIndex == 0"
                @click.prevent.stop="addCinemaSetting(CinemaIndex)"
                class="btn-transparent"
                :disabled="isRoleID"
              >
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button>
              <button
                v-else
                @click.prevent.stop="removeCinemaSettings(CinemaIndex)"
                class="btn-transparent"
              >
                <img
                  src="@/assets/img/icons/minus.svg"
                  height="35"
                  width="35"
                />
              </button>
            </div>

            <!-- DAYS -->
            <div class="row ml-2">
              <div class="col-lg-3 col-xl-2">
                <div>{{ $t("select") }} {{ $t("days") }}:</div>
              </div>
              <div class="col-lg-9 col-xl-10 pl-0">
                <div class="row">
                  <b-form-checkbox
                    v-for="(weekdaysLoop, weekdaysKey) in singleCinema.weekDays"
                    :key="weekdaysKey"
                    style="min-width: 125px"
                    class="j-checkbox mb-3"
                    @change="onChangeWeekdays($event, weekdaysKey, CinemaIndex)"
                    v-model="singleCinema.weekDays[weekdaysKey]"
                  >
                    <div class="text-capitalize">{{ weekdaysKey }}</div>
                  </b-form-checkbox>
                </div>
              </div>
            </div>

            <!-- CHARGE SETTINGS -->
            <div class="col-md-12">
              <div class="font-weight-bold mb-4">
                {{ $t("add") }} {{ $tc("charge", 2) }}
              </div>

              <div
                class="col-12"
                v-for="(
                  cinemaCharge, cinemaChargesListIndex
                ) in singleCinema.cinemaChargesList"
                :key="cinemaChargesListIndex"
              >
                <div class="row">
                  <!-- IMAGE DIMENSION -->
                  <div class="col-md-5 mb-4">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <!-- <input v-model="cinemaCharge.rc_name" type="text" required="required" /> -->
                        <label>{{ cinemaCharge.ct_name }}</label>
                      </div>
                    </div>
                    <!-- <p class="error_msg">Invalid Entry</p> -->
                  </div>
                  <div class="col-md-7">
                    <div class="row">
                      <div class="col-md-5">
                        <div
                          class="d-flex justify-content-center align-items-center p-3"
                        >
                          <label
                            >{{ cinemaCharge.pas_charge_value
                            }}{{
                              cinemaCharge.pas_is_percentage == "Y" ? "%" : ""
                            }}</label
                          >
                        </div>
                      </div>
                      <div class="col-md-5">
                        <div
                          class="d-flex justify-content-center align-items-center p-3"
                        >
                          <label>{{
                            cinemaCharge.cinemacharges
                              ? cinemaCharge.cinemacharges.toFixed(4)
                              : 0
                          }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="text-right">
                  <div>
                    <span class="font-weight-bold">Net Amount:</span>
                    <span
                      >{{ currencyData.curr_code }}
                      {{
                        singleCinema.ratecard.frc_net_amount.toFixed(MIN_FRACTION_DIGITS)
                      }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="text-right">
                  <div>
                    <span class="font-weight-bold">Gross Total:</span>
                    <span
                      >{{ currencyData.curr_code }}
                      {{
                        singleCinema.ratecard.frc_total_amount.toFixed(MIN_FRACTION_DIGITS)
                      }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="text-right">
                  <div>
                    <span class="font-weight-bold">Food Cost %:</span>
                    <span v-if="singleCinema.ratecard.frc_total_amount"
                      >{{
                        ((
                          singleCinema.itemcost_price.costprice /
                          singleCinema.ratecard.frc_total_amount
                        ).toFixed(MIN_FRACTION_DIGITS) *
                          100)
                          | RoundOff
                      }}%</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 mb-4" v-if="false">
          <label>Alternate FNB Items</label>
          <multiselect
            v-model="fnb_item.selected_alternate_items"
            track-by="item_code"
            label="item_name"
            :options="alternate_items_list"
            :multiple="true"
            placeholder="Select Alternate Items"
            :showLabels="false"
          ></multiselect>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="onResetForm()"
            class="btn-black"
          >
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="/fnb/customization"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>

    <!-- MOVIE POSTER IMAGE MODAL -->
    <b-modal
      size="lg"
      hide-footer
      ref="preview-modal"
      id="selected-image-preview-modal"
      title="FNB Image"
    >
      <img :src="_GetImagePath(fnb_item.item_image_url)" class="img-fluid" />
    </b-modal>

    <ImageGallery
      v-bind:propImageName="fnb_item.item_name"
      :img_desc="fnb_item.item_description"
      :showPercentageLoader="true"
      v-bind:openModal="showModal"
      v-bind:set_height="set_height"
      v-bind:set_width="set_width"
      v-bind:category="fnb_item.item_is_veg ? 'Veg' : 'Non Veg'"
      v-bind:menu="'A'"
      :resetImgData="false"
    ></ImageGallery>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import CinemasService from "@/services/CinemasService";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import ImageGallery from "../../ImageGallery/imageGalleryModal";
import { mapGetters } from "vuex";
import MovieService from "@/services/MovieService";
import { CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";

export default {
  components: { VueCropper, ImageGallery },
  data() {
    return {
      alternate_items_list: [],
      set_width: null,
      set_height: null,
      showModal: false,
      ms_food_categoriesCopy: [],
      searchFoodCategories: "",
      isRoleID: true,
      btenable: false,
      imgSrc: "",
      cropImg: "",
      filename: "",
      indexofthubmnail: "",
      submitted: false,
      fnb_item: {
        fc_id: "",
        item_code: "",
        item_name: "",
        item_description: "",
        recipe_id: "",
        customization_common_id: null,
        is_sundry: "N",
        item_is_veg: true,
        item_is_recipe: "",
        item_image_url: "",
        includes_egg: true,
        is_package_item: false,
        item_is_active: true,
        selected_alternate_items: [],
        selected_customizations: [],
      },
      ms_food_categories: [],
      BaseURL: "",
      recipes: [],
      currencyData: [],
      recipe_label: "",
      fc_parent_label: "",
      cinemaList: [],
      cinemaListCopy: [],

      customizations: [],
      customizationsCopy: [],
      searchCustomization: "",
      customization_name: "",

      CinemaPriceSettings: [
        {
          selectedCinema: "",
          selectedCinemas: [],
          cinema_id: null,
          recipe_label: "",
          //ITEM COST PRICE
          itemcost_price: {
            cinema_id: "",
            v_id: "",
            item_id: "",
            costprice: "",
            fp_is_active: true,
          },
          //RATE CARD

          selectedCinema: "",
          ratecard: {
            cinema_id: null,
            frc_name: "",
            frc_amount: "",
            currency_id: null,
            frc_is_active_inclusivtax: "Y",
            frc_net_amount: 0,
            frc_total_amount: 0,
          },
          selectedChargeSettingName: "",
          pas_setting_name_list: [],
          cinemaChargesList: [],
          //FNB Pricing
          ms_fnb_price: {
            cinema_id: "",
            item_id: "",
            currency_id: "",
            fnb_rate_card_id: "",
            fp_amount: "",
            fp_total_amount: "",
            fp_from_date: new Date(),
            fp_to_date: "",
            fp_is_active: true,
          },
          weekDays: {
            selectAll: true,
            sunday: true,
            monday: true,
            tuesday: true,
            wednesday: true,
            thursday: true,
            friday: true,
            saturday: true,
          },
        },
      ],
      Languages: [],
      ContentLanguages: [],
      activeClass: 0,
      FnbItemContent: [],
      notempty: [false, false, false, false, false, false],
      role_id: null,
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    this.role_id = roleid || null;
    if (true) {
      this.isRoleID = false;
      this.getCinemaList(obj);
    } else {
      this.getCinemaList(obj);
    }
    this.getGlobalOptions();
    // this.getCurrencyCode();
  },
  computed: {
    list() {
      return this.CinemaPriceSettings[index].cinemaChargesList;
    },
    showErpColumns() {
      return this.$store.getters.SHOW_ERP_GL_FIELDS == "Y" ? true : false;
    },
    qfx_tax_structure() {
      return this.authorizeClient(CLIENT_NAMES_OBJ.qfx_tax_structure);
    },
    mif_tax_calculation() {
      return this.authorizeClient(CLIENT_NAMES_OBJ.mif_tax_calculation);
    },
    fractionDigits() {
      let fracDigit = 3;
      if (this.authorizeClient(CLIENT_NAMES_OBJ.cinepolis_combo)) {
        fracDigit = 2;
      } else {
        fracDigit = 3;
      }
      return fracDigit;
    },
    ...mapGetters(["finalImagePath"]),
  },
  created() {
    this.getMovieContentLangauge();
  },
  mounted() {
    this.getRecipeList();
    this.getFoodCategoiresList();
    this.getCustomizationList();
    this.getAlternateItems();
  },
  watch: {
    finalImagePath(newval) {
      this.fnb_item.item_image_url = newval;
    },
  },
  methods: {
    getMovieContentLangauge: function () {
      MovieService.GetMovieContentLanguages()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.ContentLanguages.length > 0) {
              // this.ContentLanguages = _.sortBy(data.ContentLanguages, [
              //   "langauge"
              // ]);
              this.ContentLanguages = data.ContentLanguages;
            }
            console.log("this.ContentLanguages", this.ContentLanguages);
          } else {
            // Show Error:
            console.log("data.message :", data.message);
          }
          return;
        })
        .then(() => {
          this.makeLangContainers();
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error On getMovieContentLangauge :", error);
        });
    },
    onChangeItemName(event, type) {
      this.FnbItemContent.map((x) => {
        if (x.langauge.toLowerCase() == "english") {
          if (type == "name") {
            x.item_name = event.target.value;
          } else if (type == "desc") {
            x.item_description = event.target.value;
          }
        }
      });
    },
    makeLangContainers: function () {
      this.ContentLanguages.map((x) => {
        let Obj = {
          ...x,
          item_name: "",
          item_description: "",
        };
        this.FnbItemContent.push(Obj);
        console.log("this.FnbItemContent", this.FnbItemContent);
      });
    },
    onChangeTabHandler: function (event, index) {
      this.activeClass = index;
    },
    resetFromDate(index) {
      this.CinemaPriceSettings[index].ms_fnb_price.fp_from_date = "";
    },
    resetToDate(index) {
      this.CinemaPriceSettings[index].ms_fnb_price.fp_to_date = "";
    },
    clearCustomisation() {
      this.customization_name = "";
    },
    getAlternateItems: function () {
      PosFnbService.GetAlternateItems()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.alternate_items_list = data.Records;
          } else {
          }
        })
        .catch((error) => {
          console.log("Catch Error on getAlternateItems :", error);
        });
    },
    setModalData(height, width) {
      this.set_height = height;
      this.set_width = width;
      this.showModal = !this.showModal;
    },
    onSearchFoodCategories: function () {
      if (this.searchFoodCategories && this.searchFoodCategories.length > 0) {
        this.ms_food_categories = this.ms_food_categoriesCopy.filter((x) => {
          if (
            x.fc_category
              .toLowerCase()
              .includes(this.searchFoodCategories.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.ms_food_categories = this.ms_food_categoriesCopy;
      }
    },
    onSearchCustomization: function () {
      if (this.searchCustomization && this.searchCustomization.length > 0) {
        this.customizations = this.customizationsCopy.filter((x) => {
          if (
            x.customization_name
              .toLowerCase()
              .includes(this.searchCustomization.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.customizations = this.customizationsCopy;
      }
    },
    showFnbImage: function () {
      this.$refs["preview-modal"].show();
    },
    getCurrencyCode: function (currencyid) {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id: currencyid,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    getRecipeList: function () {
      let payload = {
        tableName: "ms_recipes",
        recipe_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.recipes = data.Records;
          } else {
            console.log("message", data.message);
            // this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onChangeWeekdays: function (event, keyname, index) {
      if (keyname !== "selectAll") {
        this.CinemaPriceSettings[index].weekDays["selectAll"] = false;
      }

      let len = Object.keys(this.CinemaPriceSettings[index].weekDays).length;
      if (keyname === "selectAll" && event) {
        Object.keys(this.CinemaPriceSettings[index].weekDays).map((x) => {
          x !== "selectAll"
            ? (this.CinemaPriceSettings[index].weekDays[x] = true)
            : "";
        });
      } else if (keyname === "selectAll" && !event) {
        Object.keys(this.CinemaPriceSettings[index].weekDays).map((x) => {
          x !== "selectAll"
            ? (this.CinemaPriceSettings[index].weekDays[x] = false)
            : "";
        });
      } else if (
        keyname !== "selectAll" &&
        this.CinemaPriceSettings[index].weekDays.selectAll
      ) {
        this.CinemaPriceSettings[index].weekDays["selectAll"] = false;
      }
    },
    addCinemaSetting: function (index) {
      this.getGlobalOptions();
      this.CinemaPriceSettings.push({
        selectedCinema: "",
        selectedCinemas: [],
        cinema_id: null,
        recipe_label: "",
        currentIndex: 0,
        report_code: "",
        gl_account: "",
        gl_desc: "",
        //ITEM COST PRICE
        itemcost_price: {
          cinema_id: "",
          v_id: "",
          item_id: "",
          costprice: "",
          fp_is_active: true,
        },
        //RATE CARD
        isRoleID: true,
        selectedCinema: "",
        cinemaList: [],
        ratecard: {
          cinema_id: null,
          frc_name: "",
          frc_amount: "",
          currency_id: null,
          frc_is_active_inclusivtax: "Y",
          frc_net_amount: 0,
          frc_total_amount: 0,
        },
        selectedChargeSettingName: "",
        pas_setting_name_list: [],
        cinemaChargesList: [],
        //FNB Pricing
        ms_fnb_price: {
          cinema_id: "",
          item_id: "",
          currency_id: "",
          fnb_rate_card_id: "",
          fp_amount: "",
          fp_total_amount: "",
          fp_from_date: new Date(),
          fp_to_date: "",
          fp_is_active: true,
        },
        weekDays: {
          selectAll: true,
          sunday: true,
          monday: true,
          tuesday: true,
          wednesday: true,
          thursday: true,
          friday: true,
          saturday: true,
        },
      });
    },
    removeCinemaSettings: function (cinemaIndex) {
      this.CinemaPriceSettings.splice(cinemaIndex, 1);
    },
    onSelectFnbItem: function (fnbItem, index) {
      this.CinemaPriceSettings[index].itemcost_price.item_id = parseInt(
        fnbItem.recipe_id
      );

      this.getItemCostPrice(
        this.CinemaPriceSettings[index].itemcost_price.cinema_id,
        fnbItem.recipe_id,
        index
      );
    },
    getFoodCategoiresList: function () {
      let payload = {
        tableName: "ms_food_categories",
        fc_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ms_food_categories = data.Records;
            this.ms_food_categoriesCopy = data.Records;
          } else {
            console.log("message", data.message);
            // this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    getCustomizationList: function () {
      let payload = {
        limit: null,
        currentPage: null,
        columnName: null,
        orderBy: null,
        searchKey: "",
        searchValue: "",
      };
      PosFnbService.GetCustomizationList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.customizations = data.Records;
            this.customizationsCopy = data.Records;
          } else {
            console.log("message", data.message);
            // this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onSelectCustomization(value) {
      this.customization_name = value.customization_name;
      this.fnb_item["customization_common_id"] = value.customization_common_id;
    },
    // setImage: function(e) {
    //   this.file = e.target.files[0];
    //   this.filename = e.target.files[0]["name"];

    //   if (this.file.type.indexOf("image/") === -1) {
    //     this.$toasted.show("Please select an image file");
    //     return;
    //   }
    //   if (typeof FileReader === "function") {
    //     const reader = new FileReader();
    //     reader.onload = event => {
    //       this.imgSrc = event.target.result;
    //       this.width = 129;
    //       this.height = 192;
    //       this.$bvModal.show("imagecropper");
    //       e.target.value = "";
    //     };
    //     reader.readAsDataURL(this.file);
    //   } else {
    //   }
    // },

    // cropImage() {
    //   // get image data for post processing, e.g. upload or setting image src
    //   this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
    //   // this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
    //   var block = this.cropImg.split(";");
    //   // Get the content type of the image
    //   var contentType = block[0].split(":")[1]; // In this case "image/gif"
    //   // get the real base64 content of the file
    //   var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
    //   // Convert it to a blob to upload
    //   var blob1 = this.b64toBlob(realData, contentType);
    //   this.uploadImage(blob1, this.filename);
    // },
    // b64toBlob(b64Data, contentType, sliceSize) {
    //   contentType = contentType || "";
    //   sliceSize = sliceSize || 512;

    //   var byteCharacters = atob(b64Data);
    //   var byteArrays = [];

    //   for (
    //     var offset = 0;
    //     offset < byteCharacters.length;
    //     offset += sliceSize
    //   ) {
    //     var slice = byteCharacters.slice(offset, offset + sliceSize);

    //     var byteNumbers = new Array(slice.length);
    //     for (var i = 0; i < slice.length; i++) {
    //       byteNumbers[i] = slice.charCodeAt(i);
    //     }

    //     var byteArray = new Uint8Array(byteNumbers);

    //     byteArrays.push(byteArray);
    //   }

    //   var blob = new Blob(byteArrays, { type: contentType });
    //   return blob;
    // },

    // uploadImage: function(image, filename) {
    //   let loader = this.$loading.show();

    //   let self = this;
    //   let formData = new FormData();
    //   formData.append("image", image, filename);
    //   formData.append("imagePath", "FnB Item Image");
    //   MasterService.GlobalUploadImage(formData)
    //     .then(response => {
    //       const { data } = response;
    //       data.message ? this.$toasted.show(data.message) : "";
    //       if (data.status) {
    //         self.fnb_item.item_image_url = data.path;
    //         this.$bvModal.hide("imagecropper");
    //       }
    //       self.BaseURL = data.BaseURL;
    //     })
    //     .catch(error => {
    //       alert(
    //         "Sorry! Something went wrong. kindly contact your administrator"
    //       );
    //     })
    //     .finally(() => {
    //       setTimeout(() => loader.hide(), 1000);
    //     });
    // },
    getItemCostPrice: function (cinema_id, item_id, index) {
      if (cinema_id && item_id) {
        PosFnbService.GetItemsCostPrice({ cinema_id, item_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.CinemaPriceSettings[index].itemcost_price.costprice =
                data.ItemCostPrice.toFixed(this.MIN_FRACTION_DIGITS);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      }
    },
    getGlobalOptions: function () {
      MasterService.GetGlobalOptions()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            data.Records.map((x) => {
              if (x.go_key === "CURRENCY") {
                this.CinemaPriceSettings.map((y, index) => {
                  this.CinemaPriceSettings[index].ratecard.currency_id =
                    x.go_value || null;
                  this.CinemaPriceSettings[index].ms_fnb_price.currency_id =
                    x.go_value || null;
                });
              }
            });
            console.log(
              "this.CinemaPriceSettings :>> ",
              this.CinemaPriceSettings
            );
          } else {
            // Show Error
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          //Catch Error
          console.log("catch error on GetGlobalOptions :", error);
        });
    },
    getCinemaList: function (cine_id) {
      // let body = this.getRequestBody("GET", undefined, {
      //   GET: "/admin/",
      //   tableName: "ms_cinemas"
      // });
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.cinemaList = data.Records;
            this.cinemaListCopy = data.Records;
            //console.log("this.cinemaList :", this.cinemaList);
            this.cinemaList.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.selectedCinema = x.cine_name;
                // if (x.currency_id == null && x.currency_id == "") {
                //   this.secureStore.get("BRGLOPCU") &&
                //     this.secureStore.get("BRGLOPCU").go_value;
                // } else {
                //   this.getCurrencyCode(x.currency_id);
                // }
                this.CinemaPriceSettings[0].selectedCinemas.push(x);
                this.onDropdownChange(x, 0);
              }
            });
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },
    // On click and Change Handler
    onDropdownChange: function (item, index) {
      // this.cinemaListCopy.push(item.cine_id);
      this.CinemaPriceSettings[index].selectedCinema = item.cine_name;
      this.CinemaPriceSettings[index].cinema_id = item.cine_id;
      this.CinemaPriceSettings[index].itemcost_price.cinema_id = item.cine_id;
      this.CinemaPriceSettings[index].ms_fnb_price.cinema_id = item.cine_id;
      this.CinemaPriceSettings[index].ratecard.cinema_id = item.cine_id;
      // this.cinemaListCopy = [];
      // this.cinemaList.map((x) => {
      //   let arr = this.CinemaPriceSettings.filter((y) => {
      //     return y.cinema_id == x.cine_id;
      //   });
      //   if (arr.length == 0) {
      //     this.cinemaListCopy.push(x);
      //   }
      // });
      this.cinemaListCopy.map((x, index) => {
        if (x.cine_id == item.cine_id) {
          this.cinemaListCopy.splice(index, 1);
        }
      });
      if (item.currency_id == null && item.currency_id == "") {
        this.secureStore.get("BRGLOPCU") &&
          this.secureStore.get("BRGLOPCU").go_value;
      } else {
        this.getCurrencyCode(item.currency_id);
      }
      this.getPasSettingName(item.cine_id, index);
    },
    getPasSettingName: function (id, index) {
      this.CinemaPriceSettings[index].pas_setting_name_list = [];
      CinemasService.GetCinemaSettingNameByCinemaId({ id })
        .then(async (response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.CinemaPriceSettings[index].pas_setting_name_list =
              data.Records;
          } else {
            // Show Error Message Here
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("catch error on GetCinemaCharges :", error);
        });
    },
    onChangeSettingName: function (event, item, index) {
      console.log("item :>> ", item);
      this.CinemaPriceSettings[index].selectedChargeSettingName =
        item.pas_charge_setting_name;
      console.log(
        "object :>> ",
        (this.CinemaPriceSettings[index].selectedChargeSettingName =
          item.pas_charge_setting_name)
      );
      this.getCinemaCharges(
        this.CinemaPriceSettings[index].ratecard.cinema_id,
        index
      );
    },
    OnSwitchHandler: function (event, index) {
      this.CinemaPriceSettings[index].ratecard.frc_is_active_inclusivtax =
        event;
      this.cinemaChargesCalculation(index);
    },
    onChangeRatecardAmount: function (event, index) {
      this.cinemaChargesCalculation(index);
    },
    calculatePercentageCharge: function (index) {
      let finalvalue = 1;
      this.CinemaPriceSettings[index].cinemaChargesList.map((x) => {
        if (x.pas_is_percentage === "Y") {
          finalvalue += parseFloat(x.pas_charge_value) / 100;
        }
      });
      return finalvalue;
    },
    getCinemaCharges: function (id, index) {
      this.CinemaPriceSettings[index].cinemaChargesList = [];
      let payload = {
        pas_charge_setting_name:
          this.CinemaPriceSettings[index].selectedChargeSettingName,
        id: id,
      };
      CinemasService.GetCinemaChargesByCinemaId(payload)
        .then(async (response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.CinemaPriceSettings[index].cinemaChargesList = data.Records;
            let promises = this.CinemaPriceSettings[
              index
            ].cinemaChargesList.map((x) => {
              x["cinemacharges"] = 0;
              return x;
            });
            await Promise.all(promises).then(() => {
              this.cinemaChargesCalculation(index);
            });
          } else {
            // Show Error Message Here
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("catch error on GetCinemaCharges :", error);
        });
    },
    getFloat(val = "0", fractionDigits = this.fractionDigits) {
      let parsed = parseFloat(String(val) || "0") || parseFloat("0");
      return +parseFloat(parsed.toFixed(fractionDigits));
    },
    cinemaChargesCalculation: function (index) {
      this.CinemaPriceSettings[index].ratecard.frc_net_amount = parseFloat(
        this.CinemaPriceSettings[index].ratecard.frc_amount
      );
      this.CinemaPriceSettings[index].ratecard.frc_total_amount = parseFloat(
        this.CinemaPriceSettings[index].ratecard.frc_amount
      );
      let FinalAmount = parseFloat(
        this.CinemaPriceSettings[index].ratecard.frc_total_amount || 0
      );
      if (this.qfx_tax_structure) {
        let grosss = this.getSafe(
          () => this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
          []
        )
          .filter((g) => String(g.ct_name).toUpperCase().includes("VAT"))
          .filter((g) => g.pas_is_percentage === "Y");

        let nets = this.getSafe(
          () => this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
          []
        )
          .filter((g) => !String(g.ct_name).toUpperCase().includes("VAT"))
          .filter((g) => g.pas_is_percentage === "Y");

        let misc_products = this.getSafe(
          () => this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
          []
        )
          .filter((g) => g.pas_is_percentage === "N")
          .filter((g) => !String(g.ct_name).toUpperCase().includes("VAT"));

        console.log({
          nets,
          grosss,
          misc_products,
          taxes: this.CinemaPriceSettings[index].cinemaChargesList.map(
            (x) => x
          ),
        });

        let vat_pas_id = this.getSafe(() => grosss[0].pas_id);
        let vat_percent = this.getFloat(
          this.getSafe(() => grosss[0].pas_charge_value, 0),
          2
        );

        let net_1_pas_id = this.getSafe(() => nets[0].pas_id);
        let net_1_percent = this.getFloat(
          this.getSafe(() => nets[0].pas_charge_value, "0"),
          2
        );

        let net_2_pas_id = this.getSafe(() => nets[1].pas_id);
        let net_2_percent = this.getFloat(
          this.getSafe(() => nets[1].pas_charge_value, "0"),
          2
        );

        let misc_product_rate_pas_id = this.getSafe(
          () => misc_products[0].pas_id
        );
        let misc_product_rate_1 = this.getFloat(
          this.getSafe(() => misc_products[0].pas_charge_value, "0"),
          2
        );
        let misc_rate_exist =
          misc_product_rate_1 > 0 && misc_product_rate_pas_id > 0;
        let amount = this.getFloat(FinalAmount);

        /** Gross */
        let G = amount;
        /** Taxable/Net */
        let E = this.getFloat(amount / (1 + vat_percent / 100));
        /** VAT */
        let F = this.getFloat((vat_percent / 100) * E);
        /** 3D/Prod */
        let B = this.getFloat(misc_product_rate_1 / (1 + vat_percent / 100));
        /** Ticket Rate */
        let totalPerCentOfA = 1 + (net_1_percent + net_2_percent) / 100;
        let A = this.getFloat((E - B) / totalPerCentOfA);
        /** Film Dev Tax */
        let C = this.getFloat((net_1_percent / 100) * A);
        /** State & Local Ent Tax */
        let D = this.getFloat((net_2_percent / 100) * A);

        console.log({
          amount,
          vat_percent,
          net_1_percent,
          net_2_percent,
          totalPerCentOfA,
          misc_rate_exist,
          misc_product_rate_1,
        });
        console.log({
          Gross: G,
          Net: E,
          VAT: F,
          FDT: C,
          SLE: D,
          "3D": B,
          TicketRate: A,
          ProductRate: B,
        });

        let NET_AMT = E;
        let BASE_RATE = A;
        let NET_1_AMT = C;
        let NET_2_AMT = D;
        let NET_3_AMT = B; // misc_product_rate_1
        let VAT_AMT = F;
        let Gross = G;

        this.CinemaPriceSettings[index].cinemaChargesList.map((x, i) => {
          if (x.pas_id == vat_pas_id) {
            x.cinemacharges = VAT_AMT;
          }
          if (x.pas_id == net_1_pas_id) {
            x["cinemacharges"] = NET_1_AMT;
          }
          if (x.pas_id == net_2_pas_id) {
            x["cinemacharges"] = NET_2_AMT;
          }
          if (x.pas_id == misc_product_rate_pas_id) {
            x["cinemacharges"] = NET_3_AMT;
          }
        });

        this.CinemaPriceSettings[index].ratecard.frc_net_amount = this.getFloat(
          BASE_RATE + NET_3_AMT
        );

        this.$forceUpdate();
      } else if (this.mif_tax_calculation) {
           let grosss = this.getSafe(
          () => this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
          []
        )
          .filter((g) => String(g.ct_name).toUpperCase().includes("VAT"))
          .filter((g) => g.pas_is_percentage === "Y");

        let nets = this.getSafe(
          () => this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
          []
        )
          .filter((g) => !String(g.ct_name).toUpperCase().includes("VAT"))
          .filter((g) => g.pas_is_percentage === "Y");

        let misc_products = this.getSafe(
          () => this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
          []
        )
          .filter((g) => g.pas_is_percentage === "N")
          .filter((g) => !String(g.ct_name).toUpperCase().includes("VAT"));

        console.log({
          nets,
          grosss,
          misc_products,
          taxes: this.CinemaPriceSettings[index].cinemaChargesList.map(
            (x) => x
          ),
        });

        let vat_pas_id = this.getSafe(() => grosss[0].pas_id);
        let vat_percent = this.getFloat(
          this.getSafe(() => grosss[0].pas_charge_value, 0),
          2
        );

        let net_1_pas_id = this.getSafe(() => nets[0].pas_id);
        let net_1_percent = this.getFloat(
          this.getSafe(() => nets[0].pas_charge_value, "0"),
          2
        );

        let net_2_pas_id = this.getSafe(() => nets[1].pas_id);
        let net_2_percent = this.getFloat(
          this.getSafe(() => nets[1].pas_charge_value, "0"),
          2
        );

        let misc_product_rate_pas_id = this.getSafe(
          () => misc_products[0].pas_id
        );
        let misc_product_rate_1 = this.getFloat(
          this.getSafe(() => misc_products[0].pas_charge_value, "0"),
          2
        );

        let all_mis_product_sum = 0;
        if (misc_products && misc_products.length) {
          all_mis_product_sum =
            this.getFloat(
              misc_products.reduce(
                (acc, { pas_charge_value }) =>
                  acc + parseFloat(pas_charge_value),
                0
              ),
              3
            ) || 0;
        }

        let misc_rate_exist =
          misc_product_rate_1 > 0 && misc_product_rate_pas_id > 0;
        let amount = this.getFloat(FinalAmount);

        /** Gross */
        let G = amount;
        /** Taxable/Net */
        let E = this.getFloat(amount / (1 + vat_percent / 100));
        /** VAT */
        let F = this.getFloat((vat_percent / 100) * E);
        /** 3D/Prod */
        let B = this.getFloat(all_mis_product_sum || 0);
        /** Ticket Rate */
        let totalPerCentOfA = 1 + (net_1_percent + net_2_percent) / 100;
        let A = this.getFloat((E - B) / totalPerCentOfA);
        /** Film Dev Tax */
        let C = this.getFloat((net_1_percent / 100) * A);
        /** State & Local Ent Tax */
        let D = this.getFloat((net_2_percent / 100) * A);

        console.log({
          amount,
          vat_percent,
          net_1_percent,
          net_2_percent,
          totalPerCentOfA,
          misc_rate_exist,
          misc_product_rate_1,
        });
        console.log({
          Gross: G,
          Net: E,
          VAT: F,
          FDT: C,
          SLE: D,
          "3D": B,
          TicketRate: A,
          ProductRate: B,
        });

        let NET_AMT = E;
        let BASE_RATE = A;
        let NET_1_AMT = C;
        let NET_2_AMT = D;
        let NET_3_AMT = B; // misc_product_rate_1
        let VAT_AMT = F;
        let Gross = G;

        this.CinemaPriceSettings[index].cinemaChargesList.map((x, i) => {
          if (x.pas_id == vat_pas_id) {
            x.cinemacharges = this.getFloat(VAT_AMT, 2);
          }
          if (x.pas_id == net_1_pas_id) {
            x["cinemacharges"] = this.getFloat(NET_1_AMT, 2);
          }
          if (x.pas_id == net_2_pas_id) {
            x["cinemacharges"] = this.getFloat(NET_2_AMT, 2);
          }
          if (x.pas_is_percentage == "N") {
            let findIndex = misc_products.findIndex(
              (mis) => mis.pas_id == x.pas_id
            );
            if (findIndex > -1) {
             x["cinemacharges"] = parseFloat(
                misc_products[findIndex]["pas_charge_value"]
              ).toFixed(2);
            }
          }
        });

        // this.CinemaPriceSettings[index].ratecard.frc_net_amount = this.getFloat(
        //   BASE_RATE + NET_3_AMT
        // );
        this.CinemaPriceSettings[index].ratecard.frc_net_amount = this.getFloat(
          BASE_RATE
        );

        this.$forceUpdate();
      } else {
        this.CinemaPriceSettings[index].cinemaChargesList.map((x) => {
          if (
            this.CinemaPriceSettings[index].ratecard
              .frc_is_active_inclusivtax === "N"
          ) {
            if (x.pas_is_percentage === "Y") {
              x.cinemacharges =
                (parseFloat(
                  this.CinemaPriceSettings[index].ratecard.frc_amount
                ) *
                  parseFloat(x.pas_charge_value)) /
                100;
            }
            this.calculateNetAmount(x, "Plus", index);
          } else if (
            this.CinemaPriceSettings[index].ratecard
              .frc_is_active_inclusivtax === "Y"
          ) {
            if (x.pas_is_percentage === "Y") {
              x.cinemacharges =
                ((parseFloat(
                  this.CinemaPriceSettings[index].ratecard.frc_amount
                ) /
                  this.calculatePercentageCharge(index)) *
                  parseFloat(x.pas_charge_value)) /
                100;
            }
            this.calculateNetAmount(x, "Minus", index);
          }
          if (x.pas_is_percentage === "N" && x.pas_is_taxable === "Y") {
            x.cinemacharges =
              parseFloat(x.pas_charge_value) *
              this.calculateTaxableCharge(index);
          } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
            x.cinemacharges = parseFloat(x.pas_charge_value);
          }
          return x;
        });
        this.$forceUpdate();
      }
    },
    cinemaChargesCalculation_old: function (index) {
      this.CinemaPriceSettings[index].ratecard.frc_net_amount = parseFloat(
        this.CinemaPriceSettings[index].ratecard.frc_amount
      );
      this.CinemaPriceSettings[index].ratecard.frc_total_amount = parseFloat(
        this.CinemaPriceSettings[index].ratecard.frc_amount
      );

      this.CinemaPriceSettings[index].cinemaChargesList.map((x) => {
        if (
          this.CinemaPriceSettings[index].ratecard.frc_is_active_inclusivtax ===
          "N"
        ) {
          if (x.pas_is_percentage === "Y") {
            x.cinemacharges =
              (parseFloat(this.CinemaPriceSettings[index].ratecard.frc_amount) *
                parseFloat(x.pas_charge_value)) /
              100;
          }
          this.calculateNetAmount(x, "Plus", index);
        } else if (
          this.CinemaPriceSettings[index].ratecard.frc_is_active_inclusivtax ===
          "Y"
        ) {
          if (x.pas_is_percentage === "Y") {
            x.cinemacharges =
              ((parseFloat(
                this.CinemaPriceSettings[index].ratecard.frc_amount
              ) /
                this.calculatePercentageCharge(index)) *
                parseFloat(x.pas_charge_value)) /
              100;
          }
          this.calculateNetAmount(x, "Minus", index);
        }
        if (x.pas_is_percentage === "N" && x.pas_is_taxable === "Y") {
          x.cinemacharges =
            parseFloat(x.pas_charge_value) * this.calculateTaxableCharge(index);
        } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
          x.cinemacharges = parseFloat(x.pas_charge_value);
        }
        return x;
      });
      this.$forceUpdate();
    },
    calculateTaxableCharge: function (index) {
      let finalvalue = 1;
      this.CinemaPriceSettings[index].cinemaChargesList.map((x) => {
        //Pick only items that are taxable
        if (x.pas_is_percentage === "Y") {
          finalvalue -= parseFloat(x.pas_charge_value) / 100;
        }
      });
      return finalvalue;
    },
    calculateNetAmount: function (x, equation, index) {
      if (equation === "Plus") {
        if (x.pas_is_percentage === "Y") {
          this.CinemaPriceSettings[index].ratecard.frc_total_amount +=
            parseFloat(x.cinemacharges);
        } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
          this.CinemaPriceSettings[index].ratecard.frc_total_amount +=
            parseFloat(x.pas_charge_value);
        } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "Y") {
          this.CinemaPriceSettings[index].ratecard.frc_total_amount +=
            parseFloat(x.pas_charge_value);
        }
      } else if (equation === "Minus") {
        if (x.pas_is_percentage === "Y") {
          this.CinemaPriceSettings[index].ratecard.frc_net_amount -= parseFloat(
            x.cinemacharges
          );
        } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
          this.CinemaPriceSettings[index].ratecard.frc_net_amount -= parseFloat(
            x.pas_charge_value
          );
        } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "Y") {
          this.CinemaPriceSettings[index].ratecard.frc_net_amount -= parseFloat(
            x.pas_charge_value
          );
        }
      }
    },
    calculatePercentageCharge: function (index) {
      let finalvalue = 1;
      this.CinemaPriceSettings[index].cinemaChargesList.map((x) => {
        if (x.pas_is_percentage === "Y") {
          finalvalue += parseFloat(x.pas_charge_value) / 100;
        }
      });
      return finalvalue;
    },
    onResetForm: function () {
      this.CinemaPriceSettings = [
        {
          selectedCinema: "",
          selectedCinemas: [],
          cinema_id: null,
          recipe_label: "",
          //ITEM COST PRICE
          itemcost_price: {
            cinema_id: "",
            v_id: "",
            item_id: "",
            costprice: "",
            fp_is_active: true,
          },
          //RATE CARD

          selectedCinema: "",
          ratecard: {
            cinema_id: null,
            frc_name: "",
            frc_amount: "",
            currency_id: null,
            frc_is_active_inclusivtax: "Y",
            frc_net_amount: 0,
            frc_total_amount: 0,
          },
          selectedChargeSettingName: "",
          pas_setting_name_list: [],
          cinemaChargesList: [],
          //FNB Pricing
          ms_fnb_price: {
            cinema_id: "",
            item_id: "",
            currency_id: "",
            fnb_rate_card_id: "",
            fp_amount: "",
            fp_total_amount: "",
            fp_from_date: new Date(),
            fp_to_date: "",
            fp_is_active: true,
          },
          weekDays: {
            selectAll: true,
            sunday: true,
            monday: true,
            tuesday: true,
            wednesday: true,
            thursday: true,
            friday: true,
            saturday: true,
          },
        },
      ];
      this.customization_name = "";

      this.fnb_item = {
        fc_id: "",
        item_code: "",
        item_name: "",
        item_description: "",
        recipe_id: "",
        customization_common_id: null,
        is_sundry: "N",
        item_is_veg: true,
        item_is_recipe: "",
        item_image_url: "",
        includes_egg: true,
        is_package_item: false,
        item_is_active: true,
      };
      this.recipe_label = "";
      this.fc_parent_label = "";
    },
    onFinalSubmit: function (flag) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        // if (this.fnb_item.item_image_url.length == 0) {
        //   return this.$toasted.show("Please Upload a Customization Image");
        // }
        if (valid) {
          // this.btenable = true;

          let loader = this.$loading.show();

          if (this.fnb_item.item_is_veg == true) {
            this.fnb_item.includes_egg = false;
          }
          let payload = {
            CinemaPriceSettings: this.CinemaPriceSettings,
            fnb_item: this.fnb_item,
            FnbItemContent: this.FnbItemContent,
            isCustomization: true,
          };
          PosFnbService.AddFnbItem(payload)
            .then((response) => {
              this.btenable = false;

              const { data } = response;
              if (data && data.status) {
                this.onResetForm();
                if (flag) {
                  this.$router.push({
                    path: "/fnb/customization",
                  });
                }
                this.$toasted.show(data.message);
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError)
            .finally(() => {
              setTimeout(() => loader.hide(), 1000);
            }); //message
        }
      });
    },
    CheckEmptyContent: function (fnbContent, index) {
      if (fnbContent.langauge.toLowerCase() !== "english") {
        if (fnbContent.item_name && fnbContent.item_description) {
          this.notempty[index] = true;
        } else {
          this.notempty[index] = false;
        }
      }
    },
  },
};
</script>

<style>
.clearDropDownBtn {
  position: absolute;
  left: 87%;
  z-index: 9999;
  width: auto;
  border: none;
  height: auto;
  font-size: 14px;
  color: #000000;
  font-weight: bold;
  background-color: transparent;
}

.chargeSettingRow {
  background: #e9ecef;
  padding: 8px;
  border-radius: 10px;
  zoom: 0.9;
}
.chargeSettingInnerWrap {
  border-radius: 15px;
  background: white;
  margin: 3px;
  padding: 12px;
}

.w-250 {
  width: 250px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/customizationComponents/addCustomizationV2.vue